export const CHECK_AUTH = "checkAuth";
export const LOGIN = "login";
export const REFRESH_TOKEN = "refreshToken";
export const LOGIN_ECP = "loginEcp";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const UPDATE_USER_ROLE = "updateUserRole";
export const GET_USER_ROLE = "getUserRole";
export const OAUTH = "oauth";
export const FETCH_PROJECTS = "fetchProjects";
export const FETCH_PROJECT_TYPES = "fetchProjectTypes";
export const FETCH_PROJECT_HISTORY = "fetchProjectHistory";
export const ADD_PROJECT = "addProject";
export const SAVE_PROJECT = "saveProject";
export const SEND_PROJECT = "sendProject";
export const RESEND_PROJECT = "reSendProject";
export const FETCH_PROJECT = "fetchProject";
export const SET_MAIN_MENU = "setMainMenu";
export const SET_IS_VIEW_ALL_EXPERTISE = "setIsViewAllExpertise";
export const FETCH_DIRECTORY = "fetchDirectory";
export const FETCH_DIRECTORIES = "fetchDirectories";
export const FETCH_NOTIFICATIONS = "fetchNotifications";
export const FETCH_METHODICS = "fetchMethodics";
export const FETCH_CALENDAR_PLAN = "fetchCalendarPlan";
export const FETCH_EXPERTISES = "fetchExpertises";
export const FETCH_EXPERTISES_LIST = "fetchExpertisesList";
export const FETCH_ALL_EXPERTISES_LIST = "fetchAllExpertisesList";
export const FETCH_EXPERTISE_DETAILS = "fetchExpertiseDetails";
export const FETCH_EXPERTS = "fetchExperts";
export const FETCH_EXPERTS_LIST = "fetchExpertsList";
export const FETCH_QUESTIONS_LIST = "fetchQuestionsList";
export const FETCH_EXPERT_PROJECT = "fetchExpertProject";
export const FETCH_EXPERT_PROJECT_LIST = "fetchExpertProjectsList";
export const FETCH_GROUP_ORGS = "fetchGroupOrgs";
export const FETCH_GROUP_ORGS_LIST = "fetchGroupOrgsList";
export const FETCH_GROUP_ORGS_LIZING = "fetchGroupOrgsLizing";
export const FETCH_MONITORING_LIZING_ORGS = "fetchMonitoringLizingOrgs";
export const FETCH_MONITORING_LIZING_ORGS_LIST =
  "fetchMonitoringLizingOrgsList";
export const FETCH_REQUEST = "fetchRequest";
export const FETCH_REQUESTS = "fetchRequests";
export const FETCH_REQUEST_CHAT = "fetchRequestChat";
export const FETCH_ADMIN_LIST = "fetchAdminList";

export const FETCH_ADMIN_STATUS_DOCS_LIST = "fetchAdminStatusDocsList";
export const FETCH_ADMIN_INFO_DOC_LIST = "fetchAdminInfoDocList";

export const FETCH_LIST_QUESTION_CONFERENCE = "fetchListQuestionConference";

export const FETCH_SUBMITTED = "fetchSubmitted";

export const FETCH_ABOUT_PROJECT = "fetchAboutProject";
export const FETCH_SCENARIO_PROJECT = "fetchScenarioProject";
